module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMzU0NDYgMjAuNjc1M0wxMS44NTQ1IDEyLjE3NTNMMjAuMzU0NSAyMC42NzUzTTIwLjM1NDUgMy42NzUyOUwxMS44NTI4IDEyLjE3NTNMMy4zNTQ0NiAzLjY3NTI5IiBzdHJva2U9IiM1NTU1NTUiIHN0cm9rZS13aWR0aD0iNS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/close.svg
// module id = d3CT
// module chunks = 0